"use client";

import { ICompetitorPageStaticData } from "api/interfaces/static-pages/competitor-pages.type";
import { RootState } from "interfaces/generics.type";
import HomeContainer from "modules/home/HomeContainer";
import { useEffect } from "react";
import { useSelector } from "react-redux";

interface IProps {
  homeJson: ICompetitorPageStaticData;
}
function CarParts(props: IProps) {
  const { homeJson } = props;
  const { highTrafficPageData, isOldBuildId } = homeJson || {};
  const { averageRating, totalReviewCount } = useSelector((store: RootState) => store.authenticationState);

  useEffect(() => {
    if (isOldBuildId) {
      window.location.reload();
    } else {
      // getSitejabberBusinessInfoApi().then(({ data }) => {
      //   setSitejaberData(data);
      // });
    }
  }, []);

  if (isOldBuildId) {
    return null;
  }

  const staticContent = {
    ...homeJson,
    pageDetails: {
      pageDisplayableTitle: highTrafficPageData?.pageDisplayableTitle,
    },
  };

  const updatedJson = {
    ...homeJson,
    bannersWebp: highTrafficPageData?.bannersV2,
  };

  return (
    <HomeContainer
      homeJson={updatedJson}
      googleReviewSummary={{ overallRating: averageRating, totalReviews: totalReviewCount }}
      staticContent={staticContent}
      showBreadCrumb
      contentIds={highTrafficPageData?.contentIds}
      meta={highTrafficPageData?.meta}
    />
  );
}

export default CarParts;
